import { Observable, of } from 'rxjs';
import { ofType } from 'src/core/engine/rxjs/ofType';
import { catchError, concatMap, mergeMap, withLatestFrom } from 'rxjs';
import { execute as removeMine } from 'swagger/ts/QuoteCouponManagementV1RemoveDelete2';
import { execute as removeGuest } from 'swagger/ts/QuoteGuestCouponManagementV1RemoveDelete';
import { CartVariant, CartMsg, cartVariantAndId } from 'src/core/state/cart';
import { EpicDeps } from 'src/core/engine/types';
import { extractErrorAndCode } from 'swagger/utils/ajax-helpers';
import Bugsnag from '@bugsnag/js';

import { Actions, CouponMsg } from './coupon.register';

export function removeCouponEpic(action$: Observable<any>, state$: Observable<any>, deps: EpicDeps) {
    return action$.pipe(
        ofType<Actions>('Coupon.Delete'),
        withLatestFrom(cartVariantAndId(state$)),
        concatMap(([, [variant, cartId]]) => {
            const payload = { cartId: cartId as any };
            const ajax$ = variant === CartVariant.Account ? removeMine(deps) : removeGuest(payload, deps);
            return ajax$.pipe(
                mergeMap(() => of(CartMsg('Cart.Refresh', { force: true }), CouponMsg('Coupon.DeleteSuccess'))),
                catchError((err) => {
                    const { error, code } = extractErrorAndCode(err);
                    Bugsnag.notify(error, (event) => {
                        event.addMetadata('code', { code: code });
                    });
                    return of(CouponMsg('Coupon.DeleteError', error), CartMsg('Cart.Refresh', { force: true }));
                }),
            );
        }),
    );
}
